import { useTranslation } from "@/core/i18n";
import { ActionModal } from "molecules/modal-window/action-modal/ActionModal";

interface RetryMembershipPaymentFailedModalProps {
  paymentMethodLast4?: string | null;
  onClose: () => void;
}

export const RetryMembershipPaymentFailedModal = ({
  paymentMethodLast4,
  onClose,
}: RetryMembershipPaymentFailedModalProps) => {
  const { t } = useTranslation();

  return (
    <ActionModal
      size="small"
      open
      onClose={onClose}
      onFirstButtonClick={onClose}
      firstButtonLabel={t("retryMembershipPaymentFailedModal.manageButton")}
      title={t("retryMembershipPaymentFailedModal.title")}
      description={
        <div className="px-2">
          {paymentMethodLast4
            ? t("retryMembershipPaymentFailedModal.descriptionWithCard", {
                last4: paymentMethodLast4,
              })
            : t("retryMembershipPaymentFailedModal.descriptionNoCard")}
        </div>
      }
    />
  );
};
